import EmblaCarousel from "embla-carousel";
import "../css/carousel.css";

document.addEventListener("DOMContentLoaded", () => {
  const emblaNode = document.querySelector(".embla");
  if (!emblaNode) return;

  const options = { loop: true };
  const embla = EmblaCarousel(emblaNode, options);

  const slides = emblaNode.querySelectorAll(".embla__slide");

  const updateScale = () => {
    slides.forEach((slide, index) => {
      slide.classList.toggle(
        "is-selected",
        embla.selectedScrollSnap() === index
      );
    });
  };

  embla.on("select", updateScale);
  updateScale();
});
